import { call, put, select } from 'redux-saga/effects';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
import { withOffset } from '../../Stream';
import { requestNapi } from '@wix/da-http-client/pkg/request';
import { FetchType } from '../../Stream/base/types';
export function fakeResponse({ params }) {
    if (process.env.NODE_ENV !== 'production') {
        const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        const { Chance } = require('chance'); // eslint-disable-line global-require
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        const randomDeviations = new Chance().pickset(deviationsByType.commissions, 10);
        return {
            hasMore: false,
            deviations: randomDeviations
        };
    }
}
function* fetch(url, params) {
    const response = yield call(requestNapi, {
        method: 'get',
        url,
        params
    }, fakeResponse);
    return response;
}
function* handleCommissionStreamFetch(action) {
    const { streamId } = action;
    const offset = yield select((state)=>withOffset.selectors.getNextOffset(state, streamId));
    const response = yield call(fetch, 'commission/list', {
        offset
    });
    if (!response) {
        yield put(withOffset.actions.fetchFailure({
            streamId,
            fetchType: FetchType.Next,
            errorMsg: 'Failed to fetch'
        }));
        return;
    }
    const { deviations, hasMore, nextOffset } = response;
    const normalized = deviations && normalizeDeviations(deviations);
    var _normalized_result, _normalized_entities;
    yield put(withOffset.actions.fetchSuccess({
        streamId,
        hasMore: !!hasMore,
        nextOffset,
        items: (_normalized_result = normalized === null || normalized === void 0 ? void 0 : normalized.result) !== null && _normalized_result !== void 0 ? _normalized_result : [],
        entities: (_normalized_entities = normalized === null || normalized === void 0 ? void 0 : normalized.entities) !== null && _normalized_entities !== void 0 ? _normalized_entities : {}
    }));
}
export default handleCommissionStreamFetch;

//# sourceMappingURL=commissionStreamFetch.js.map